import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { GlobalStyles } from '@playbookux/playbook-web-core';
import Route from '../core/components/route';
import PrivateRoute from '../core/components/private-route';
// pages
import CardSort from './pages/card-sort';
// import Dashboard from './pages/dashboard';
import Download from './pages/download-screen';
import DownloadMobile from './pages/download-mobile';
import GuestTester from './pages/guest-tester';
import LinkedInCallback from './pages/linkedin-callback';
import PathfixCallback from './pages/pathfix-callback';
import RecruitParticipants from './pages/recruit-participants';
import Schedule from './pages/schedule';
import ScheduleConfirmation from './pages/schedule-confirmation';
import ScreenerSession from './pages/screener-session/index';
import ScreenerSessionDisqualified from './pages/screener-session/disqualified';
import ScreenerSessionError from './pages/screener-session/error';
import ScreenerSessionOutdated from './pages/screener-session/outdated';
import ScreenerSessionSuccess from './pages/screener-session/conclusion';
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up';
import SignUpSurvey from './pages/sign-up-survey';
import ProfileSummary from './pages/profile-summary';
import Settings from './pages/account-settings';
import Faqs from './pages/faqs';
import Summary from './pages/schedule-summary';
import UnmoderatedSession from './pages/unmoderated-session';
import Unsubscribe from './pages/unsubscribe';
import WelcomePage from './pages/welcome';
import Survey from './pages/survey/index';
import ThankYouPage from './pages/thank-you';
import InstructionsTester from './pages/instructions-tester';
import TreeTestTask from './pages/tree-test-task/index';
import PracticeTest from './pages/practice-test';
import BrowseTests from './pages/browse-tests';
import Congratulations from './pages/congratulations';
import CompletedTests from './pages/completed-tests';
import VideoInstruction from './pages/video-instruction';
import PracticeTestInstructions from './pages/practice-test-instructions';
import Blocked from './pages/blocked';
import Rejected from './pages/rejected';
import ConsentForm from './pages/consent-form';
import VideoPlayer from './pages/video-player';
import AudioPlayer from './pages/audio-player';
import TesterRoot from './pages/tester-root';
import { DemographicsSurvey } from './pages/demographics-survey';
import { MaintenancePage } from '../core/pages/maintenance';
import HealthCheck from '../core/components/health-check';
import ModeratedTestLink from './pages/moderated-test-link';

const RoutesTester = ({ history }) => (
  <>
    <GlobalStyles />
    <Router history={history}>
      <Switch>
        <Route
          exact
          path="/healthcheck"
          component={HealthCheck}
          isPublicRoute
        />

        {/* public environment */}
        <Route exact path="/linkedin/callback" component={LinkedInCallback} />
        <Route exact path="/pathfix/callback" component={PathfixCallback} />
        <Route exact path="/sign-in" component={SignIn} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route exact path="/download" component={Download} isPublicRoute />
        <Route
          exact
          path="/download-mobile"
          component={DownloadMobile}
          isPublicRoute
        />
        <Route
          exact
          path="/screener-session"
          component={ScreenerSession}
          isPublicRoute
        />
        <Route
          exact
          path="/screener-session/disqualified"
          component={ScreenerSessionDisqualified}
          isPublicRoute
        />
        <Route
          exact
          path="/screener-session/success"
          component={ScreenerSessionSuccess}
          isPublicRoute
        />
        <Route
          exact
          path="/screener-session/error"
          component={ScreenerSessionError}
          isPublicRoute
        />
        <Route
          exact
          path="/screener-session/outdated"
          component={ScreenerSessionOutdated}
          isPublicRoute
        />
        <Route
          exact
          path="/unmoderated-session"
          component={UnmoderatedSession}
          isPublicRoute
        />
        <Route
          exact
          path="/unsubscribe"
          component={Unsubscribe}
          isPublicRoute
        />
        <Route
          exact
          path="/recruit-participants"
          component={RecruitParticipants}
          isPublicRoute
        />
        <Route
          exact
          path="/guest-tester"
          component={GuestTester}
          isPublicRoute
        />
        <Route exact path="/schedule" component={Schedule} isPublicRoute />
        <Route
          exact
          path="/schedule/confirmation"
          component={ScheduleConfirmation}
          isPublicRoute
        />
        <Route
          exact
          path="/schedule/summary"
          component={Summary}
          isPublicRoute
        />
        <Route
          exact
          path="/maintenance"
          component={MaintenancePage}
          isPublicRoute
        />

        <Route
          exact
          path="/video-player"
          component={VideoPlayer}
          isPublicRoute
        />

        <Route
          exact
          path="/moderated-meeting"
          component={ModeratedTestLink}
          isPublicRoute
        />

        <Route
          exact
          path="/audio-player"
          component={AudioPlayer}
          isPublicRoute
        />

        {/* Tester environment */}
        <PrivateRoute exact path="/consent-form" component={ConsentForm} />
        <PrivateRoute exact path="/welcome" component={WelcomePage} />
        <PrivateRoute exact path="/thank-you" component={ThankYouPage} />
        <PrivateRoute exact path="/card-sort" component={CardSort} />
        <PrivateRoute
          exact
          path="/instructions-tester"
          component={InstructionsTester}
        />
        <PrivateRoute exact path="/survey" component={Survey} />
        <PrivateRoute exact path="/tree-test-task" component={TreeTestTask} />
        <PrivateRoute exact path="/practice-test" component={PracticeTest} />
        <PrivateRoute exact path="/faqs" component={Faqs} />
        <PrivateRoute
          exact
          path="/demographics-survey"
          component={DemographicsSurvey}
        />
        <PrivateRoute
          exact
          path="/completed-tests"
          component={CompletedTests}
        />
        <PrivateRoute
          exact
          path="/video-instruction"
          component={VideoInstruction}
        />
        <PrivateRoute
          exact
          path="/practice-test-instructions"
          component={PracticeTestInstructions}
        />
        <PrivateRoute exact path="/" component={TesterRoot} />
        <PrivateRoute exact path="/browse-tests" component={BrowseTests} />
        <PrivateRoute
          exact
          path="/congratulations"
          component={Congratulations}
        />
        <PrivateRoute exact path="/profile" component={SignUpSurvey} />
        <PrivateRoute exact path="/settings" component={Settings} />
        <PrivateRoute exact path="/sign-up/survey" component={SignUpSurvey} />
        <PrivateRoute
          exact
          path="/profile-summary"
          component={ProfileSummary}
        />
        <PrivateRoute exact path="/blocked" component={Blocked} />
        <PrivateRoute exact path="/rejected" component={Rejected} />
      </Switch>
    </Router>
  </>
);

RoutesTester.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default RoutesTester;
